import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Typography } from '@telus-uds/components-web';

import { Thead, Tr, Th, Td } from './css';
import getFormattedPricing from '../../utils';
import Row from './row';

const Table = ({ viewType, service, setService, list, total, setTotal }) => {
  const getHeader = headerList => (
    <Thead>
      <Tr>
        {headerList.map(item => (
          <Th>{_.get(item, 'fields.title', '')}</Th>
        ))}
      </Tr>
    </Thead>
  );

  useEffect(() => {
    const grandTotal = Object.keys(service).reduce((acc, current) => {
      const { unitPrice, quantity } = service[current];
      return acc + unitPrice * +quantity;
    }, 0);
    setTotal(previousValue => ({
      ...previousValue,
      geotabBundles: grandTotal
    }));
  }, [service]);

  return (
    <table>
      {list.map(item =>
        _.get(item, 'fields.isHeader', false) ? (
          getHeader(_.get(item, 'fields.headerList', []))
        ) : (
          <Row
            key={`geotab-bundles-row-${_.get(item, 'fields.addonName')}`}
            rowData={item}
            viewType={viewType}
            service={service}
            setService={setService}
          />
        )
      )}
      <Tr style={{ background: '#f4f4f4' }}>
        <Td colSpan={4}>
          <Typography variant={{ bold: true }}>Total</Typography>
        </Td>
        <Td>
          <Typography variant={{ bold: true }}>{getFormattedPricing(total)}</Typography>
        </Td>
      </Tr>
    </table>
  );
};

Table.propTypes = {
  viewType: PropTypes.string.isRequired,
  service: PropTypes.shape({}).isRequired,
  setService: PropTypes.func.isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired
};

export default Table;
